// src/components/listing/specialized/SpecializedForm.jsx
import React from 'react';
import ElectronicsForm from './ElectronicsForm';
import ServicesForm from './ServicesForm';
import VehiclesForm from './VehiclesForm';
import PropertiesForm from './PropertiesForm';

const SpecializedForm = ({ 
  categoryType, 
  form,
  errors, 
  submitting, 
  onFieldChange 
}) => {
  
  const categoryId = form.subcategory_id;
  
  // console.log('🔍 SpecializedForm debug:', {
  //   categoryType,
  //   categoryId,
  //   formKeys: Object.keys(form)
  // });

  const renderForm = () => {
    switch (categoryType) {
      case 'electronics':
        return (
          <ElectronicsForm 
            form={form}
            errors={errors}
            submitting={submitting}
            onFieldChange={onFieldChange}
            categoryId={categoryId} 
          />
        );
      case 'services':
        return (
          <ServicesForm 
            form={form}
            errors={errors}
            submitting={submitting}
            onFieldChange={onFieldChange}
            categoryId={categoryId} 
          />
        );
      case 'vehicles':
        return (
          <VehiclesForm 
            form={form}
            errors={errors}
            submitting={submitting}
            onFieldChange={onFieldChange}
            categoryId={categoryId}
          />
        );
      case 'properties':
        return (
          <PropertiesForm 
            form={form}
            errors={errors}
            submitting={submitting}
            onFieldChange={onFieldChange}
            categoryId={categoryId}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Additional Details</h3>
      <p className="text-gray-600 text-sm mb-6">
        Please provide additional information about your {categoryType}
      </p>
      {renderForm()}
    </div>
  );
};

export default SpecializedForm;